<script>
    import ProviderEditHeader from '@/components/page-provider-and-game-edit/provider-edit/ProviderEditHeader.vue';
    import ProviderEditData from '@/components/page-provider-and-game-edit/provider-edit/ProviderEditData.vue';
    import ProviderEditImage from '@/components/page-provider-and-game-edit/provider-edit/ProviderEditImage.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_PAG_RROVIDER_EDIT}
        },
        components: {
            ProviderEditHeader: ProviderEditHeader,
            ProviderEditData: ProviderEditData,
            ProviderEditImage: ProviderEditImage,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <ProviderEditHeader />
        <hr class="hr_light_98">
        <ProviderEditData />
        <hr class="hr_light_98">
        <ProviderEditImage />
    </div>
</template>